import api from './api';
import {
  hydrateDisputeCollection,
  hydrateDisputeRecord
} from '../utils/translationHydrator';

const hydrateDisputePayload = (payload) => {
  if (!payload) {
    return payload;
  }

  if (Array.isArray(payload.data)) {
    return { ...payload, data: hydrateDisputeCollection(payload.data) };
  }

  if (payload.data) {
    return { ...payload, data: hydrateDisputeRecord(payload.data) };
  }

  return payload;
};

/**
 * Service générique pour les disputes accessibles par un user
 * N'importe quel user connecté peut lister ses disputes
 */
class DisputeService {
  /**
   * List disputes of the authenticated user
   * GET /user/disputes
   */
  async listUser(params = {}) {
    const response = await api.get('/disputes/user/disputes', { params });
    return hydrateDisputePayload(response.data);
  }

  /**
   * Get a single dispute by ID
   * GET /disputes/:disputeId
   */
  async get(disputeId) {
    const response = await api.get(`/disputes/${disputeId}`);
    return hydrateDisputePayload(response.data);
  }
}

export default new DisputeService();
